export const texts = {
  fr: {
    general: {
      metatitle: "1000SHAKE – Le shaker parfait en 30 secondes",
      metadescription: "Découvrez 1000SHAKE, la machine intelligente qui prépare vos shakes protéinés ou matcha parfaitement mixés en 30 secondes, sans effort et sans grumeaux."
    },
    home: {
      title: "Accueil",
      heroTitle: "Précision Robotique des Boissons",
      heroSubtitle: "La fusion de l'artisanat et de l'automatisation",
      heroButton: "Découvrir Maintenant",
      heroPhrases: [
        "1000Shake - Les shakers qui boostent votre établissement",
      ],
      heroLogoName: "Off Course",

      missionTitle: "Pourquoi adopter notre distributeur",
      missionParts: [
        "Générez un revenu complémentaire sans effort grâce à une solution automatisée et rentable pour votre espace.",
        "Proposez une expérience fluide et attractive mêlant personnalisation des saveurs, rapidité et design intuitif.",
        "Intégrez un distributeur entièrement personnalisé à l'image de votre établissement : couleurs, logo, messages.",
        "Offrez un service disponible 24h/24, 7j/7 sans personnel, facile à recharger, nettoyer et entretenir.",
        "Contrôlez votre machine en toute simplicité via une interface dédiée : réglages, recettes, performances en temps réel.",
      ],
      missionPreviousButton: "Précédent",
      missionNextButton: "Suivant",

      valuesTitle: "Technologie Avancée de Boissons",
      valuesSectionValues: [
        {
          title: "Composition Parfaite",
          description:
            "La machine reproduit fidèlement les gestes humains pour une préparation homogène et soignée."+
            "\n Chaque boisson est réalisée avec des ingrédients sélectionnés et des dosages précis, sans additifs superflus",
          icon: "/icons/precision.svg",
          tags: ["Précision", "IA"],
        },
        {
          title: "Recettes Personnalisées",
          description:
            "Proposez une large gamme de recettes adaptées aux objectifs de vos clients : prise de masse, "+
            "récupération, tonus, bien-être. Les formules sont modulables selon les préférences et besoins nutritionnels.",
          icon: "/icons/recipes.svg",
          tags: ["Convivial", "Flexible"],
        },
        {
          title: "Supervision en temps réel",
          description:
            "La machine assure un suivi technique en continu. Vous accédez à des données en temps réel sur son état et suivez les statistiques d'utilisation.",
          icon: "/icons/monitoring.svg",
          tags: ["IoT", "Contrôle à Distance"],
        },
        {
          title: "Disponibilité continue ",
          description:
          "La machine fonctionne de manière autonome 24h/24 et 7j/7, sans supervision. "+
          "Elle garantit un service permanent, même en dehors des horaires d'ouverture." ,
          icon: "/icons/eco.svg",
          tags: ["Durable", "Écologique"],
        },
        {
          title: "Entretien Simple",
          description:
            "Grâce à son système de nettoyage automatisé, l'entretien quotidien est réduit au strict minimum. "+
            "La machine reste propre, fonctionnelle et conforme aux normes d'hygiène.",
          icon: "/icons/maintenance.svg",
          tags: ["Gain de Temps", "Fiable"],
        },
        {
          title: "Analyse de Données",
          description:
            "Un tableau de bord complet vous permet d'accéder à l'ensemble des données de consommation, "+
            "d'utilisation et de performance. Un outil clé pour piloter votre activité avec précision.",
          icon: "/icons/analytics.svg",
          tags: ["Insights Business", "Optimisation"],
        },
      ],

      teamTitle: "L'Équipe",
      teamSectionMembers: [
        {
          name: "Luigi",
          role: "Co-Fondateur",
          image: "/luigi.jpg",
          description: `Luigi développe le réseau, gère la relation client et construit l'approche commerciale. Il intervient également sur les actions marketing`,
        },
        {
          name: "Elias",
          role: "Co-Fondateur",
          image: "/elias.jpg",
          description: `Elias Travaille à la fois sur l'acquisition, la communication et la structuration marketing. `+
          `Il participe aussi activement à la commercialisation terrain`,
        },
      ],

      partnersTitle: "Nos Partenaires",
      partnersSectionData: {
        stores: {
          topImages: ["/gym_1.jpg", "/gym_2.jpg", "/gym_3.jpg"],
          bottomImages: [
            {
              src: "/image_de_marque.jpg",
              name: "Design intégré",
              description: "Valorise votre image de marque ",
            },
            {
              src: "/simple_efficace.webp",
              name: "Simple et Efficae",
              description: "Boisson prête en moins de 30 secondes",
            },
            {
              src: "/rituel.png",
              name: "Rituel post-effort",
              description: "Fidélise vos membres/clients",
            },
            {
              src: "/bien_etre.jpg",
              name: "Bien-être global",
              description: "Les bons compléments au bon moment",
            },
            {
              src: "/24_7.png",
              name: "Présence continue",
              description: "Un service autonome et disponible 24/7",
            },
          ],
          hoverTexts: [
            "Une pause alignée avec chaque objectif",
            "Une touche de récupération dans le flow d'un training",
            "Un prolongement naturel de l'effort",
            "Pensé pour les corps qui avancent",
            "Le bon repère après le bon geste",
          ],
        },
        fashionDesigners: {
          topImages: [
            "/coworking_1.jpg",
            "/coworking_2.jpg",
            "/coworking_3.jpg",
          ],
          bottomImages: [
            {
              src: "/Creatine.png",
              name: "Créatine monohydrate",
              description: "Le classique pour la puissance et la force",
            },
            {
              src: "/Collagen.png",
              name: "Collagen",
              description: "Récupération et réduction de la fatigue",
            },
            {
              src: "/BCAA.png",
              name: "BCAA instantanés",
              description:
                "Apport calorique contrôlé pour progresser.",
            },
            {
              src: "/Whey.png",
              name: "Protéine isolate",
              description: "Vitalité et soutien quotidien optimisé",
            },
            {
              src: "/multiple_shakes.png",
              name: "Saveurs variées",
              description: "Autant de combinaisons que d'envies",
            },
          ],
          hoverTexts: [
            "A break aligned with every goal",
            "A touch of recovery in the training flow",
            "A natural extension of the effort",
            "Designed for bodies in motion",
            "The right recovery after the right move",
          ],
        },
        recyclingCompanies: {
          topImages: ["/mall_1.jpg", "/mall_2.jpg", "/mall_3.jpg"],
          bottomImages: [
            {
              src: "/rentable.png",
              name: "Modèle rentable",
              description:
                "Un retour sur investissement en moins d'un an.",
            },
            {
              src: "/levier.webp",
              name: "Nouveau levier ",
              description:
                "Une nouvelle source de revenu",
            },
            {
              src: "/couts_faible.jpg",
              name: "Couts faibles",
              description:
                "Des couts d'exploitation relativement bas",
            },
            {
              src: "/installation.jpg",
              name: "Installation rapide",
              description:
                "Installer votre machine sans effort",
            },
            {
              src: "/SAV.png",
              name: "Suivi assuré",
              description:
                "1 an de garantis et un SAV a vie",
            },
          ],
          hoverTexts: [
            "An anchor point in movement",
            "A quick service, in an equally fast world",
            "Discreet, efficient, always within reach",
            "A welcome reference between moments",
            "Designed to exist without disrupting",
          ],
        },
      },
      partnersTabStores: "Experience Complète",
      partnersTabDesigners: "Offre Variée",
      partnersTabRecycling: "Rentabilité Immédiate",

      featuresTitle: "Nos Atouts",
      videoSrc: "/Teaser_1000Shake.mp4",

      ctaTitle: "Découvrez les Machines",
      ctaButton: "Demander une Démo",
    },
    protein: {
      title: "Machines à Protéines",
      heroText: "Conçu pour les salles de sport",
      section1:
        "Conçu pour les salles de sport - texte expliquant les avantages pour les propriétaires de salles de sport.",
      section2: "Goûtez la différence - texte sur la texture artisanale.",
      testimonials: "Avis réels des propriétaires de salles de sport",
    },
    matcha: {
      title: "Machines à Matcha",
      heroText: "Conçu pour les cafés et les studios de pilates",
      section1:
        "Conçu pour les cafés et les studios de pilates - texte sur l'élégance et l'efficacité.",
      section2: "Goût artisanal, précision robotique - texte.",
      testimonials: "Adoré par les amateurs de matcha",
    },
    contact: {
      title: "Nous contacter",
      description:
      "Vous souhaitez proposer 1000Shake à vos clients ? Prenez contact avec nous !",
      address: "Adresse",
      phone: "Téléphone",
      email: "Email",
      form: {
        nameLabel: "Votre Nom",
        namePlaceholder: "Entrez votre nom complet",
        emailLabel: "Votre Email",
        emailPlaceholder: "Entrez votre adresse email",
        subjectLabel: "Sujet",
        subjectPlaceholder: "Quel est l'objet de votre message ?",
        messageLabel: "Message",
        messagePlaceholder:
          "Dites-nous ce dont vous avez besoin ou posez une question...",
        submitButton: "Envoyer le Message",
        successMessage:
          "Votre message a été envoyé avec succès. Nous vous répondrons bientôt !",
        errorMessage:
          "Une erreur s'est produite lors de l'envoi de votre message. Veuillez réessayer.",
      },
    },
    models: {
      title: "Nos modèles",
      items: [
        {
          id: 1,
          title: "Machine Pro X1",
          description:
            "Notre modèle phare pour les professionnels exigeants. Performance et fiabilité garanties pour une productivité optimale.",
          image: "/3_machines.jpg",
        },
        {
          id: 2,
          title: "Eco Series E2",
          description:
            "Solution écologique et économique, parfaite pour les petites et moyennes entreprises soucieuses de l'environnement.",
          image: "/machine_2.jpg",
        },
        {
          id: 3,
          title: "Ultra Compact U3",
          description:
            "Format compact sans compromis sur la qualité. Idéal pour les espaces restreints avec des performances exceptionnelles.",
          image: "/Single_Big_Machine.png",
        },
      ],
    },
    machine: {
      title: "Machine",
      subtitle: "Technologie Avancée",
      description: "Notre machine de boisson à la pointe de la technologie combine une ingénierie de précision avec une technologie innovante pour offrir des boissons parfaites à chaque fois. Conçue pour les professionnels recherchant fiabilité et constance.",
      
      headerAutomation: "Automatisation complète",
      headerQualityControl: "Contrôle de qualité",
      headerEcoFriendly: "Écologique",
      headerConnected: "Connecté",
      
      featuresTitle: "Caractéristiques Principales",
      features: [
        {
          title: "Système de Distribution Intelligent",
          subtitle: "Précision maximale",
          description: "Mesure avec précision les ingrédients pour une saveur et une texture constantes dans chaque boisson.",
          icon: "coffee"
        },
        {
          title: "Interface Tactile Intuitive",
          subtitle: "Simple d'utilisation",
          description: "Interface utilisateur intuitive pour une sélection et une personnalisation rapides des boissons.",
          icon: "mobile"
        },
        {
          title: "Économe en Énergie",
          subtitle: "Écologique",
          description: "Conception écologique qui réduit la consommation d'énergie tout en maintenant des performances optimales.",
          icon: "leaf"
        },
        {
          title: "Connexion Cloud",
          subtitle: "Toujours connecté",
          description: "Supervision à distance en temps réel avec statistiques de vente et gestion des stocks.",
          icon: "wifi"
        },
        {
          title: "Préparation Rapide",
          subtitle: "Efficacité maximale",
          description: "La technologie avancée de chauffage et de mélange délivre des boissons en moins de 30 secondes.",
          icon: "rocket"
        },
        {
          title: "Auto-Nettoyage",
          subtitle: "Maintenance minimale",
          description: "Système autonettoyant qui réduit le temps d'entretien et garantit l'hygiène.",
          icon: "wrench"
        }
      ],
      
      modelsTitle: "Nos Modèles",
      modelsDescription: "Choisissez le modèle qui correspond le mieux aux besoins de votre entreprise. Chaque machine est conçue avec précision pour offrir des performances exceptionnelles.",
      
      gallery: {
        image: "Image",
        previous: "Précédent",
        next: "Suivant",
        zoomIn: "Zoom avant",
        zoomOut: "Zoom arrière"
      },
      
      modelElite: {
        name: "1000Shake Elite",
        nameAlt: "1000Shake Elite",
        description: "Notre modèle phare professionnel avec automatisation complète, distribution intelligente et connectivité IoT. Parfait pour les cafés et centres de fitness à fort volume. La machine comprend un contrôle avancé de la température, des recettes personnalisables et une fonction d'auto-nettoyage.",
        isPremium: true,
        highlights: [
          "Écran tactile 27 pouces",
          "7 réservoirs de 4L chacun",
          "Système de mélange haute densité",
          "Connexion Wi-Fi + 4G"
        ],
        specs: {
          technical: {
            name: "Caractéristiques Techniques",
            items: [
              { name: "Design", value: "Personnalisable" },
              { name: "Puissance", value: "1800 W" },
              { name: "Écran", value: "Écran tactile 27 pouces, système Android" },
              { name: "Méthodes de paiement", value: "QR code, pièces, billets, carte bancaire, monnaie" },
              { name: "Connexion", value: "Wi-Fi + 4G" },
              { name: "Alimentation en eau", value: "Pompe intégrée (besoin d'aucune installation spécifique)" },
              { name: "Sortie eau", value: "Chauffée + refroidie (0 à 95°C)" },
              { name: "Porte de distribution", value: "Porte automatique" }
            ]
          },
          dimensions: {
            name: "Dimensions & Poids",
            items: [
              { name: "Dimensions", value: "757 mm (L) × 670 mm (P) × 1800 mm (H)" },
              { name: "Empreinte au sol", value: "Seulement 0,5 m²" },
              { name: "Capacité des réservoirs", value: "7 réservoirs de 4 L chacun" },
              { name: "Capacité gobelets", value: "Distributeur automatique de 100 à 120 gobelets" }
            ]
          },
          performance: {
            name: "Performance",
            items: [
              { name: "Préparation", value: "Préparation individualisée dans chaque gobelet" },
              { name: "Mélange", value: "Mélange homogène grâce à un système de mixage haute densité" },
              { name: "Réglage", value: "Réglage du temps et de la vitesse de chaque mélange" },
              { name: "Nettoyage", value: "Tête de mixage nettoyée automatiquement entre chaque utilisation" },
              { name: "Transit", value: "Transit intelligent des gobelets avec axe multiple pour une production fluide" }
            ]
          },
          smart: {
            name: "Système Intelligent",
            items: [
              { name: "Supervision", value: "Supervision à distance en temps réel" },
              { name: "Statistiques", value: "Statistiques de vente, gestion des stocks, alertes panne" },
              { name: "Gestion", value: "Gestion des membres et des promotions" },
              { name: "Analyse", value: "Analyse de données et suivi des anomalies" },
              { name: "Marketing", value: "Gestion marketing & visuelle" }
            ]
          },
          service: {
            name: "Services",
            items: [
              { name: "Garantie", value: "Garantie 1 an sur l'ensemble de la machine" },
              { name: "Maintenance", value: "Maintenance à vie" },
              { name: "Installation", value: "Installation et configuration" },
              { name: "Formation", value: "Formation à l'utilisation" }
            ]
          }
        }
      },
      
      modelMini: {
        name: "1000Shake Compact",
        nameAlt: "1000Shake Compact",
        description: "Une version rationalisée de notre modèle professionnel, conçue pour les espaces plus petits sans compromettre la qualité. Idéal pour les petites salles de sport, les petits cafés et les magasins d'alimentation santé. Présente des capacités d'automatisation essentielles avec des commandes simplifiées.",
        isPremium: false,
        highlights: [
          "Écran tactile 18,5 pouces",
          "4 réservoirs de 4L chacun",
          "Design compact et élégant",
          "Connexion Wi-Fi + 4G"
        ],
        specs: {
          technical: {
            name: "Caractéristiques Techniques",
            items: [
              { name: "Design", value: "Personnalisable" },
              { name: "Puissance", value: "1000 W" },
              { name: "Écran", value: "Écran tactile 18,5 pouces, système Android" },
              { name: "Méthodes de paiement", value: "QR code, carte bancaire" },
              { name: "Connexion", value: "Wi-Fi + 4G" },
              { name: "Alimentation en eau", value: "Pompe intégrée (besoin d'aucune installation spécifique)" },
              { name: "Sortie eau", value: "Chauffée + refroidie (0 à 95°C)" },
              { name: "Porte de distribution", value: "Porte automatique" }
            ]
          },
          dimensions: {
            name: "Dimensions & Poids",
            items: [
              { name: "Dimensions", value: "52 cm (H) × 70 cm (L) × 58 cm (P)" },
              { name: "Empreinte au sol", value: "Seulement 0,4 m²" },
              { name: "Capacité des réservoirs", value: "4 réservoirs de 4 L chacun" },
              { name: "Capacité gobelets", value: "Distributeur automatique de 80 à 100 gobelets" }
            ]
          },
          performance: {
            name: "Performance",
            items: [
              { name: "Préparation", value: "Préparation individualisée dans chaque gobelet" },
              { name: "Mélange", value: "Mélange homogène grâce à un système de mixage haute densité" },
              { name: "Réglage", value: "Réglage du temps et de la vitesse de chaque mélange" },
              { name: "Nettoyage", value: "Tête de mixage nettoyée automatiquement entre chaque utilisation" },
              { name: "Transit", value: "Transit intelligent des gobelets avec axe multiple pour une production fluide" }
            ]
          },
          smart: {
            name: "Système Intelligent",
            items: [
              { name: "Supervision", value: "Supervision à distance en temps réel" },
              { name: "Statistiques", value: "Statistiques de vente, gestion des stocks, alertes panne" },
              { name: "Gestion", value: "Gestion des membres et des promotions" },
              { name: "Analyse", value: "Analyse de données et suivi des anomalies" },
              { name: "Marketing", value: "Gestion marketing & visuelle" }
            ]
          }
        }
      }
    },
    modelsSection: {
      title: "Nos Machines",
      models: [
        {
          id: 1,
          title: "1000Shake Pro",
          description: "Notre modèle phare professionnel avec automatisation complète, distribution intelligente et connectivité IoT. Parfait pour les cafés et centres de fitness à fort volume. La machine comprend un contrôle avancé de la température, des recettes personnalisables et une fonction d'auto-nettoyage. Construit avec des matériaux durables, il offre des performances fiables et une qualité constante.",
          image: "/Single_Big_Machine.png"
        },
        {
          id: 2,
          title: "1000Shake Compact",
          description: "Une version rationalisée de notre modèle professionnel, conçue pour les espaces plus petits sans compromettre la qualité. Idéal pour les petites salles de sport, les petits cafés et les magasins d'alimentation santé. Présente des capacités d'automatisation essentielles avec des commandes simplifiées et un encombrement réduit. Excellentes performances et fiabilité dans un design compact.",
          image: "/Single_Small_Machine.png"
        }
      ],
      moreInfoButton: "Plus d'informations",
      discoverButton: "Découvrir les machines"
    },
    faq: {
      title: "Foire Aux Questions",
      questions: [
        {
          question: "Comment fonctionne la machine 1000shake ?",
          answer:
            "La machine permet aux utilisateurs de sélectionner une boisson protéinée via un écran tactile. Elle dose, mélange et sert automatiquement la boisson dans un gobelet, avec un nettoyage du mélangeur entre chaque utilisation.",
        },
        {
          question:
            "Quelle est la différence entre les modèles standard et compact ?",
          answer:
            "• 1000shake Standard : Plus grande capacité (7 réservoirs), écran tactile 27 pouces, porte automatique, adaptée aux grands espaces.\n• 1000shake Compact : Format réduit, 4 réservoirs, écran 18,5 pouces, parfaite pour les espaces restreints.",
        },
        {
          question: "Combien de recettes peut-on proposer ?",
          answer:
            "La machine peut accueillir plus de 20 saveurs, grâce à un système de dosage de poudre intelligent.",
        },
        {
          question: "Combien de temps faut-il pour servir une boisson ?",
          answer:
            "Moins d'une minute. La machine est optimisée pour la rapidité, sans compromis sur le goût ou la qualité de mixage.",
        },
        {
          question: "Peut-on suivre la machine à distance ?",
          answer:
            "Oui, via un système cloud intégré. Tu peux consulter les ventes, recevoir des alertes techniques, modifier les recettes ou promotions à distance.",
        },
        {
          question: "Quelle est l'alimentation en eau nécessaire ?",
          answer: "La machine fonctionne avec un réservoir intégré à pompe.",
        },
        {
          question: "Quels moyens de paiement sont acceptés ?",
          answer:
            "QR code, carte bancaire, espèces (pièces/billets), selon les configurations choisies.",
        },
        {
          question: "Est-ce que la machine se nettoie toute seule ?",
          answer:
            "Oui. Le mélangeur est automatiquement nettoyé entre chaque préparation pour garantir l'hygiène.",
        },
        {
          question: "Quelle maintenance prévoir ?",
          answer:
            "Nous offrons un service de maintenance à vie, une garantie d'un an, ainsi qu'un accompagnement technique permanent. La machine est conçue pour un usage intensif et fiable.",
        },
      ],
    },
    images: {
      machines: {
        elite: {
          main: "/Single_Big_Machine.png",
          gallery: [
            "/Single_Big_Machine.png",
            "/3_machines.jpg",
            "/7_tubes.jpg",
            "/7_Recipient_2.jpg",
            "/melangeur_3.jpg",
            "/melangeur_2.jpg", 
            "/versement.jpg",
            "/7_Recipient_2.jpg",
            "/7_Recipient_2.jpg",
          ],
          display: "/Machine_display.png",
          single: "/Single_Big_Machine.png"
        },
        mini: {
          main: "/Single_Small_Machine.png",
          gallery: [
            "/Single_Small_Machine.png",
            "/petite_interieur.png",
            "/versement.jpg",
            "/melangeur_3.jpg",
          ],
          single: "/Single_Small_Machine.png"
        },
        placeholder: "/machine_placeholder.jpg"
      },
      team: {
        luigi: "/luigi.jpg",
        elias: "/elias.jpg"
      }
    },
  },
  en: {
    general: {
      metatitle: "1000SHAKE – The perfect shaker in 30 seconds",
      metadescription: "Discover 1000SHAKE, the intelligent machine that prepares your protein or matcha shakes perfectly mixed in 30 seconds, effortlessly and without lumps."
    },
    home: {
      title: "Home",
      heroTitle: "Robotic Beverage Precision",
      heroSubtitle: "The fusion of craftsmanship and automation",
      heroButton: "Discover Now",
      heroPhrases: [
        "1000Shake - Shakers that boost your establishment",
      ],
      heroLogoName: "Off Course",

      missionTitle: "Why Choose Our Dispenser",
      missionParts: [
        "Generate additional revenue effortlessly with an automated and profitable solution for your space.",
        "Offer a smooth and attractive experience combining flavor customization, speed and intuitive design.",
        "Integrate a fully customized dispenser reflecting your establishment's identity: colors, logo, messages.",
        "Provide a service available 24/7 without staff, easy to refill, clean and maintain.",
        "Control your machine with ease through a dedicated interface: settings, recipes, real-time performance.",
      ],
      missionPreviousButton: "Previous",
      missionNextButton: "Next",

      valuesTitle: "Advanced Beverage Technology",
      valuesSectionValues: [
        {
          title: "Perfect Composition",
          description:
            "The machine faithfully reproduces human gestures for homogeneous and careful preparation."+
            "\n Each drink is made with selected ingredients and precise dosages, without unnecessary additives",
          icon: "/icons/precision.svg",
          tags: ["Precision", "AI"],
        },
        {
          title: "Customized Recipes",
          description:
            "Offer a wide range of recipes adapted to your customers' goals: mass gain, "+
            "recovery, energy, well-being. Formulas are adjustable according to preferences and nutritional needs.",
          icon: "/icons/recipes.svg",
          tags: ["Friendly", "Flexible"],
        },
        {
          title: "Real-time Supervision",
          description:
            "The machine ensures continuous technical monitoring. You have access to real-time data on its status and can track usage statistics.",
          icon: "/icons/monitoring.svg",
          tags: ["IoT", "Remote Control"],
        },
        {
          title: "Continuous Availability",
          description:
            "The machine operates autonomously 24/7, without supervision. "+
            "It guarantees permanent service, even outside opening hours.",
          icon: "/icons/eco.svg",
          tags: ["Sustainable", "Ecological"],
        },
        {
          title: "Simple Maintenance",
          description:
            "Thanks to its automated cleaning system, daily maintenance is reduced to a minimum. "+
            "The machine remains clean, functional and compliant with hygiene standards.",
          icon: "/icons/maintenance.svg",
          tags: ["Time Saving", "Reliable"],
        },
        {
          title: "Data Analytics",
          description:
            "A complete dashboard gives you access to all consumption, usage and performance data. A key tool for precisely managing your business.",
          icon: "/icons/analytics.svg",
          tags: ["Business Insights", "Optimization"],
        },
      ],

      teamTitle: "The Team",
      teamSectionMembers: [
        {
          name: "Luigi",
          role: "Co-Founder",
          image: "/luigi.jpg",
          description: `Luigi develops the network, manages customer relationships and builds the commercial approach. He also works on marketing actions`,
        },
        {
          name: "Elias",
          role: "Co-Founder",
          image: "/elias.jpg",
          description: `Elias works on acquisition, communication and marketing structure. `+
          `He also actively participates in field sales`,
        },
      ],

      partnersTitle: "Our Partners",
      partnersSectionData: {
        stores: {
          topImages: ["/gym_1.jpg", "/gym_2.jpg", "/gym_3.jpg"],
          bottomImages: [
            {
              src: "/image_de_marque.jpg",
              name: "Integrated Design",
              description: "Enhances your brand image",
            },
            {
              src: "/simple_efficace.webp",
              name: "Simple and Effective",
              description: "Drink ready in less than 30 seconds",
            },
            {
              src: "/rituel.png",
              name: "Post-workout Ritual",
              description: "Loyalty for your members/clients",
            },
            {
              src: "/bien_etre.jpg",
              name: "Overall Well-being",
              description: "The right supplements at the right time",
            },
            {
              src: "/24_7.png",
              name: "Continuous Presence",
              description: "An autonomous service available 24/7",
            },
          ],
          hoverTexts: [
            "A break aligned with every goal",
            "A touch of recovery in the training flow",
            "A natural extension of the effort",
            "Designed for bodies in motion",
            "The right recovery after the right move",
          ],
        },
        fashionDesigners: {
          topImages: [
            "/coworking_1.jpg",
            "/coworking_2.jpg",
            "/coworking_3.jpg",
          ],
          bottomImages: [
            {
              src: "/Creatine.png",
              name: "Creatine Monohydrate",
              description: "The classic for power and strength",
            },
            {
              src: "/Collagen.png",
              name: "Collagen",
              description: "Recovery and fatigue reduction",
            },
            {
              src: "/BCAA.png",
              name: "Instant BCAA",
              description: "Controlled caloric intake for progress",
            },
            {
              src: "/Whey.png",
              name: "Isolate Protein",
              description: "Optimized vitality and daily support",
            },
            {
              src: "/multiple_shakes.png",
              name: "Various Flavors",
              description: "As many combinations as desires",
            },
          ],
          hoverTexts: [
            "A break aligned with every goal",
            "A touch of recovery in the training flow",
            "A natural extension of the effort",
            "Designed for bodies in motion",
            "The right recovery after the right move",
          ],
        },
        recyclingCompanies: {
          topImages: ["/mall_1.jpg", "/mall_2.jpg", "/mall_3.jpg"],
          bottomImages: [
            {
              src: "/rentable.png",
              name: "Profitable Model",
              description: "Return on investment in less than a year",
            },
            {
              src: "/levier.webp",
              name: "New Lever",
              description: "A new source of revenue",
            },
            {
              src: "/couts_faible.jpg",
              name: "Low Costs",
              description: "Relatively low operating costs",
            },
            {
              src: "/installation.jpg",
              name: "Quick Installation",
              description: "Install your machine effortlessly",
            },
            {
              src: "/SAV.png",
              name: "Assured Support",
              description: "1 year warranty and lifetime after-sales service",
            },
          ],
          hoverTexts: [
            "An anchor point in movement",
            "A quick service, in an equally fast world",
            "Discreet, efficient, always within reach",
            "A welcome reference between moments",
            "Designed to exist without disrupting",
          ],
        },
      },
      partnersTabStores: "Complete Experience",
      partnersTabDesigners: "Varied Offer",
      partnersTabRecycling: "Immediate Profitability",

      featuresTitle: "Our Features",
      videoSrc: "/Teaser_1000Shake.mp4",

      ctaTitle: "Discover the Machines",
      ctaButton: "Request a Demo",
    },
    protein: {
      title: "Protein Machines",
      heroText: "Designed for gyms",
      section1: "Designed for gyms - text explaining benefits for gym owners.",
      section2: "Taste the difference - text about artisanal texture.",
      testimonials: "Real feedback from gym owners",
    },
    matcha: {
      title: "Matcha Machines",
      heroText: "Designed for cafés and pilates studios",
      section1: "Designed for cafés and pilates studios - text about elegance and efficiency.",
      section2: "Artisanal taste, robotic precision - text.",
      testimonials: "Loved by matcha enthusiasts",
    },
    contact: {
      title: "Contact Us",
      description: "Would you like to offer 1000Shake to your customers? Get in touch with us!",
      address: "Address",
      phone: "Phone",
      email: "Email",
      form: {
        nameLabel: "Your Name",
        namePlaceholder: "Enter your full name",
        emailLabel: "Your Email",
        emailPlaceholder: "Enter your email address",
        subjectLabel: "Subject",
        subjectPlaceholder: "What is this regarding?",
        messageLabel: "Message",
        messagePlaceholder: "Tell us what you need or ask a question...",
        submitButton: "Send Message",
        successMessage: "Your message has been sent successfully. We'll get back to you soon!",
        errorMessage: "There was an error sending your message. Please try again.",
      },
    },
    machine: {
      title: "Machine",
      subtitle: "Advanced Technology",
      description: "Our state-of-the-art beverage machine combines precision engineering with innovative technology to deliver perfect drinks every time. Designed for professionals seeking reliability and consistency.",
      
      headerAutomation: "Complete automation",
      headerQualityControl: "Quality control",
      headerEcoFriendly: "Eco-friendly",
      headerConnected: "Connected",
      
      featuresTitle: "Key Features",
      features: [
        {
          title: "Smart Dispensing System",
          subtitle: "Maximum precision",
          description: "Precisely measures ingredients for consistent flavor and texture in every drink.",
          icon: "coffee"
        },
        {
          title: "Intuitive Touch Interface",
          subtitle: "Easy to use",
          description: "Intuitive user interface for quick drink selection and customization.",
          icon: "mobile"
        },
        {
          title: "Energy Efficient",
          subtitle: "Eco-friendly",
          description: "Eco-friendly design that reduces energy consumption while maintaining optimal performance.",
          icon: "leaf"
        },
        {
          title: "Cloud Connection",
          subtitle: "Always connected",
          description: "Real-time remote monitoring with sales statistics and inventory management.",
          icon: "wifi"
        },
        {
          title: "Quick Preparation",
          subtitle: "Maximum efficiency",
          description: "Advanced heating and mixing technology delivers drinks in under 30 seconds.",
          icon: "rocket"
        },
        {
          title: "Self-Cleaning",
          subtitle: "Minimal maintenance",
          description: "Self-cleaning system that reduces maintenance time and ensures hygiene.",
          icon: "wrench"
        }
      ],
      
      modelsTitle: "Our Models",
      modelsDescription: "Choose the model that best fits your business needs. Each machine is precision-engineered to deliver exceptional performance.",
      
      gallery: {
        image: "Image",
        previous: "Previous",
        next: "Next",
        zoomIn: "Zoom In",
        zoomOut: "Zoom Out"
      },
      
      modelElite: {
        name: "1000Shake Elite",
        nameAlt: "1000Shake Elite",
        description: "Our flagship professional model featuring full automation, smart dispensing, and IoT connectivity. Perfect for high-volume cafes and fitness centers. The machine includes advanced temperature control, customizable recipes, and self-cleaning functionality.",
        isPremium: true,
        highlights: [
          "27-inch touchscreen display",
          "7 reservoirs of 4L each",
          "High-density mixing system",
          "Wi-Fi + 4G connectivity"
        ],
        specs: {
          technical: {
            name: "Technical Specs",
            items: [
              { name: "Design", value: "Customizable" },
              { name: "Power", value: "1800 W" },
              { name: "Display", value: "27-inch touchscreen, Android system" },
              { name: "Payment Methods", value: "QR code, coins, bills, credit card, change" },
              { name: "Connectivity", value: "Wi-Fi + 4G" },
              { name: "Water Supply", value: "Integrated pump (no specific installation needed)" },
              { name: "Water Output", value: "Heated + cooled (0 to 95°C)" },
              { name: "Distribution Door", value: "Automatic door" }
            ]
          },
          dimensions: {
            name: "Dimensions & Weight",
            items: [
              { name: "Dimensions", value: "757 mm (W) × 670 mm (D) × 1800 mm (H)" },
              { name: "Floor Space", value: "Only 0.5 m²" },
              { name: "Reservoir Capacity", value: "7 reservoirs of 4L each" },
              { name: "Cup Capacity", value: "Automatic dispenser of 100 to 120 cups" }
            ]
          },
          performance: {
            name: "Performance",
            items: [
              { name: "Preparation", value: "Individualized preparation in each cup" },
              { name: "Mixing", value: "Homogeneous mixing with high-density mixing system" },
              { name: "Adjustment", value: "Adjustment of time and speed for each mix" },
              { name: "Cleaning", value: "Mixing head automatically cleaned between each use" },
              { name: "Transit", value: "Intelligent cup transit with multiple axis for smooth production" }
            ]
          },
          smart: {
            name: "Smart System",
            items: [
              { name: "Supervision", value: "Real-time remote supervision" },
              { name: "Statistics", value: "Sales statistics, inventory management, failure alerts" },
              { name: "Management", value: "Member management and promotions" },
              { name: "Analysis", value: "Data analysis and anomaly tracking" },
              { name: "Marketing", value: "Marketing & visual management" }
            ]
          },
          service: {
            name: "Service",
            items: [
              { name: "Warranty", value: "1-year warranty on the entire machine" },
              { name: "Maintenance", value: "Lifetime maintenance" },
              { name: "Installation", value: "Installation and configuration" },
              { name: "Training", value: "Training on usage" }
            ]
          }
        }
      },
      
      modelMini: {
        name: "1000Shake Compact",
        nameAlt: "1000Shake Compact",
        description: "A streamlined version of our professional model, designed for smaller spaces without compromising on quality. Ideal for boutique gyms, small cafes, and health food shops. Features essential automation capabilities with simplified controls.",
        isPremium: false,
        highlights: [
          "18.5-inch touchscreen display",
          "4 reservoirs of 4L each",
          "Compact and elegant design",
          "Wi-Fi + 4G connectivity"
        ],
        specs: {
          technical: {
            name: "Technical Specs",
            items: [
              { name: "Design", value: "Customizable" },
              { name: "Power", value: "1000 W" },
              { name: "Display", value: "18.5-inch touchscreen, Android system" },
              { name: "Payment Methods", value: "QR code, credit card" },
              { name: "Connectivity", value: "Wi-Fi + 4G" },
              { name: "Water Supply", value: "Integrated pump (no specific installation needed)" },
              { name: "Water Output", value: "Heated + cooled (0 to 95°C)" },
              { name: "Distribution Door", value: "Automatic door" }
            ]
          },
          dimensions: {
            name: "Dimensions & Weight",
            items: [
              { name: "Dimensions", value: "52 cm (H) × 70 cm (W) × 58 cm (D)" },
              { name: "Floor Space", value: "Only 0.4 m²" },
              { name: "Reservoir Capacity", value: "4 reservoirs of 4L each" },
              { name: "Cup Capacity", value: "Automatic dispenser of 80 to 100 cups" }
            ]
          },
          performance: {
            name: "Performance",
            items: [
              { name: "Preparation", value: "Individualized preparation in each cup" },
              { name: "Mixing", value: "Homogeneous mixing with high-density mixing system" },
              { name: "Adjustment", value: "Adjustment of time and speed for each mix" },
              { name: "Cleaning", value: "Mixing head automatically cleaned between each use" },
              { name: "Transit", value: "Intelligent cup transit with multiple axis for smooth production" }
            ]
          },
          smart: {
            name: "Smart System",
            items: [
              { name: "Supervision", value: "Real-time remote supervision" },
              { name: "Statistics", value: "Sales statistics, inventory management, failure alerts" },
              { name: "Management", value: "Member management and promotions" },
              { name: "Analysis", value: "Data analysis and anomaly tracking" },
              { name: "Marketing", value: "Marketing & visual management" }
            ]
          }
        }
      }
    },
    modelsSection: {
      title: "Our Machines",
      models: [
        {
          id: 1,
          title: "1000Shake Pro",
          description: "Our flagship professional model featuring full automation, smart dispensing, and IoT connectivity. Perfect for high-volume cafes and fitness centers. The machine includes advanced temperature control, customizable recipes, and self-cleaning functionality. Built with durable materials, it offers reliable performance and consistent quality.",
          image: "/Single_Big_Machine.png"
        },
        {
          id: 2,
          title: "1000Shake Compact",
          description: "A streamlined version of our professional model, designed for smaller spaces without compromising on quality. Ideal for boutique gyms, small cafes, and health food shops. Features essential automation capabilities with simplified controls and a smaller footprint. Great performance and reliability in a space-saving design.",
          image: "/Single_Small_Machine.png"
        }
      ],
      moreInfoButton: "More Information",
      discoverButton: "Discover machines"
    },
    faq: {
      title: "Frequently Asked Questions",
      questions: [
        {
          question: "How does the 1000Shake machine work?",
          answer: "The machine allows users to select a protein beverage through a touchscreen interface. It automatically doses, blends and serves the drink in a cup, with mixer cleaning between each use.",
        },
        {
          question: "What's the difference between the standard and compact models?",
          answer: "• 1000Shake Standard: Larger capacity (7 reservoirs), 27-inch touchscreen, automatic door, suitable for larger spaces.\n• 1000Shake Compact: Reduced format, 4 reservoirs, 18.5-inch screen, perfect for restricted spaces.",
        },
        {
          question: "How many recipes can be offered?",
          answer: "The machine can accommodate more than 20 flavors, thanks to an intelligent powder dosing system.",
        },
        {
          question: "How long does it take to serve a drink?",
          answer: "Less than a minute. The machine is optimized for speed, without compromising taste or mixing quality.",
        },
        {
          question: "Can the machine be monitored remotely?",
          answer: "Yes, through an integrated cloud system. You can view sales, receive technical alerts, modify recipes or promotions remotely.",
        },
        {
          question: "What water supply is needed?",
          answer: "The machine operates with an integrated pump reservoir.",
        },
        {
          question: "What payment methods are accepted?",
          answer: "QR code, credit card, cash (coins/bills), depending on the chosen configurations.",
        },
        {
          question: "Does the machine clean itself?",
          answer: "Yes. The mixer is automatically cleaned between each preparation to ensure hygiene.",
        },
        {
          question: "What maintenance should be expected?",
          answer: "We offer lifetime maintenance service, a one-year warranty, and ongoing technical support. The machine is designed for intensive and reliable use.",
        },
      ],
    },
    images: {
      machines: {
        elite: {
          main: "/Single_Big_Machine.png",
          gallery: [
            "/Single_Big_Machine.png",
            "/3_machines.jpg",
            "/7_tubes.jpg",
            "/7_Recipient_2.jpg",
            "/melangeur_3.jpg",
            "/melangeur_2.jpg", 
            "/versement.jpg",
            "/7_Recipient_2.jpg",
            "/7_Recipient_2.jpg",
          ],
          display: "/Machine_display.png",
          single: "/Single_Big_Machine.png"
        },
        mini: {
          main: "/Single_Small_Machine.png",
          gallery: [
            "/Single_Small_Machine.png",
            "/petite_interieur.png",
            "/versement.jpg",
            "/melangeur_3.jpg",
          ],
          single: "/Single_Small_Machine.png"
        },
        placeholder: "/machine_placeholder.jpg"
      },
      team: {
        luigi: "/luigi.jpg",
        elias: "/elias.jpg"
      }
    },
  },
};


